import CountertopCommon from "../countertopCommon";
import Appliance from "../../parts/appliance";
import {LayoutAbbreviations, METADATA} from "../../constants";

export default class Countertop extends CountertopCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'countertop';
    this.partName = 'Countertop';
    this.translateId = "visualizer.kitchen.countertop.countertop";
    this.isStoneFeature = true;
    this.hasAdditionalParts = true;
    this.allWallsCanBeApplied = true;
    if (isChild) {
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    this.fixEdgeMeta(dbFeature);
    if (dbFeature.metaData["MountType"] && dbFeature.metaData["MountType"].includes("0")) {
      dbFeature.metaData["MountType"] = [METADATA.ALL]
    }
    if (dbFeature.metaData["MountWidth"] && dbFeature.metaData["MountWidth"].includes("0")) {
      dbFeature.metaData["MountWidth"] = [METADATA.ALL]
    }
    const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 1 ? 1 : 2;
    return super.load_(dbFeature, new Countertop(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  getCurrentSinkMetaData() {
    const sinkParent = this.getParent().sink;
    let metaObject = {};
    if (sinkParent && sinkParent.activeFeature) {
      const sinkMeta = sinkParent.activeFeature.metaData["MountType"];
      if (sinkMeta && (sinkMeta !== "0") && !sinkMeta.includes("0")) {
        metaObject["MountType"] = Array.isArray(sinkMeta) ? sinkMeta[0] : sinkMeta
      }
      const mountWidthMeta = sinkParent.activeFeature.metaData["MountWidth"];
      if (mountWidthMeta && (mountWidthMeta !== "0") && !mountWidthMeta.includes("0")) { // if 0 - we are showing all faucets
        metaObject["MountWidth"] = mountWidthMeta
      }
    }
    return metaObject
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const currentSinkMetaData = this.getCurrentSinkMetaData();
    ["MountType", "MountWidth"].forEach(propName => {
      if (currentSinkMetaData[propName]) {
        conditions.push({
          propName,
          propValue: currentSinkMetaData[propName]
        })
      }
    })
    // console.log("conditions", conditions);
    return conditions;
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const conditionsWithoutSink = arrayOfConditions.filter(condition => {
        return condition.propName !== "MountType" && condition.propName !== "MountWidth"
      })

      const countertopParent = this.getParent();
      const applianceParent = countertopParent.layout.parts[Appliance.id];
      // const sink = countertopParent.sink;

      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")
          && applianceParent && applianceParent.stove && !applianceParent.stove.disabled && applianceParent.stove.activeFeature) {
          return false
        }
        // if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")
        //   && sink && !sink.disabled && sink.activeFeature && sink.activeFeature.metaData["MountType"] && sink.activeFeature.metaData["MountType"].includes("ST")
        //   && !feature.matchesMetaForCondition("MountType", "ST")) {
        //   return false
        // }
        if (feature.metaData["Part"] && (feature.metaData["Part"].includes("2") || feature.metaData["Part"].includes("3"))) {
          return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(conditionsWithoutSink)
        }
        return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }
}
